<div class="link-account-container container pt-4">
    <div class="link-account-header">
        <div class="ms-3">
            <h5 class="app-module-title m-0">
                Vinculación de cuentas
            </h5>
            <p class="app-module-subtitle small-label">Vamos a comenzar</p>
        </div>
    </div>
    <div class="link-account-content">
        <mat-horizontal-stepper #stepper linear>
            <mat-step>
                <div class="select-link-type">
                    <div class="select-link-type-header pt-4"></div>
                    <div class="select-link-type-content multiple-separation">
                        <div mat-ripple
                             class="add-login-option card-theme-color theme-shadow"
                             (click)="changeAccountType('sms')">
                            <div class="d-flex flex-row align-items-center">
                                <span class="material-symbols-rounded add-login-option-icon">phone</span>
                                <div class="ms-3">
                                    <strong>Número de teléfono</strong>
<!--                                    <p class="small-label">Acceder con número de teléfono</p>-->
                                </div>
                            </div>
                            <span class="material-symbols-rounded">arrow_forward</span>
                        </div>
                        <div mat-ripple
                             class="add-login-option card-theme-color theme-shadow"
                             (click)="changeAccountType('email')">
                            <div class="d-flex flex-row align-items-center">
                                <span class="material-symbols-rounded add-login-option-icon">email</span>
                                <div class="ms-3">
                                    <strong>Correo electrónico</strong>
<!--                                    <p class="small-label">Acceder con dirección de correo</p>-->
                                </div>
                            </div>
                            <span class="material-symbols-rounded">arrow_forward</span>
                        </div>
                    </div>
                    <div class="select-link-type-bottom">
                    </div>
                </div>
            </mat-step>
            <mat-step [editable]="!onLastStep"
                      [completed]="validUser && (!alreadyAccountExists && !unableToCheckAccount)">
                <div class="input-field-card">
                    <!-- Correo o telefono para vincular -->
                    <input type="hidden" [formControl]="categoria">
                    <div>
                        <p class="small-label m-0">
                            Ingresa el {{
                            (accountType === 'email')
                                ? 'Correo electrónico'
                                : 'Número de teléfono'
                            }}
                        </p>
                    </div>
                    <div class="form-responsive my-4">
                        <div *ngIf="accountType === 'email'; else phoneInput">
                            <mat-form-field floatLabel="never"
                                            class="w-100">
                                <input matInput
                                       inputmode="email"
                                       [formControl]="usuario"
                                       [class.is-invalid]="alreadyAccountExists"
                                       placeholder="Correo electrónico">
                            </mat-form-field>
                        </div>
                        <ng-template #phoneInput>
                            <div class="multiple-separation-no-resp w-100">
                                <mat-form-field floatLabel="never" [ngStyle]="{ 'width': '100px' }">
                                    <mat-select [formControl]="lada">
                                        <mat-select-trigger>
                                            +{{ lada.value }}
                                        </mat-select-trigger>
                                        <mat-option value="52" selected>
                                            +52 (Mexico)
                                        </mat-option>
                                        <mat-option value="1">
                                            +1 (Estados Unidos)
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field floatLabel="never"
                                                [ngStyle]="{ 'flex-grow': '1' }">
                                    <input matInput
                                           [formControl]="usuario"
                                           inputmode="tel"
                                           [class.is-invalid]="alreadyAccountExists"
                                           placeholder="Número de teléfono"
                                           mask="(000) 000-0000">
                                </mat-form-field>
                            </div>
                        </ng-template>
                    </div>
                    <ng-container *ngIf="requirePassInLink">
                        <div class="input-field-card">
                            <mat-form-field floatLabel="never">
                                <div class="d-flex">
                                    <input matInput
                                           id="password"
                                           [type]="pwdVisibility ? 'text' : 'password'"
                                           [formControl]="password"
                                           placeholder="Contraseña">
                                    <mat-icon (click)="passwordVisibility()"
                                              [ngStyle]="{'color':'#0c4d94'}">
                                        {{ pwdVisibility ? 'visibility' : 'visibility_off' }}
                                    </mat-icon>
                                </div>
                            </mat-form-field>
                        </div>
                    </ng-container>
                    <mat-hint class="text-danger" *ngIf="invalidAccount">
                        <img src="../../assets/img/error-circle-100.svg"
                             width="32"
                             height="32"
                             alt="Account Error">
                        Este {{ (accountType === 'email')
                        ? 'correo electrónico'
                        : 'número de teléfono'
                        }} es invalido.
                    </mat-hint>
                    <mat-hint class="text-danger" *ngIf="alreadyAccountExists">
                        <img src="../../assets/img/error-circle-100.svg"
                             width="32"
                             height="32"
                             alt="Account Error">
                        Esta cuenta ya esta siendo utilizada.
                    </mat-hint>
                    <mat-hint class="text-danger" *ngIf="unableToCheckAccount">
                        <img src="../../assets/img/error-circle-100.svg"
                             width="32"
                             height="32"
                             alt="Account Error">
                        No podemos verificar la cuenta en este momento. Intenta de nuevo en unos momentos.
                    </mat-hint>
                </div>
            </mat-step>
            <mat-step [editable]="!onLastStep"
                      [completed]="validType && validName"
                      [ngStyle]="{ 'width': '-webkit-fill-available' }">
                <ng-template matStepLabel></ng-template>
                <div>
                    <p class="small-label m-0">
                        Selecciona el tipo de cuenta
                    </p>
                </div>
                <div class="multiple-separation my-4">
                    <mat-form-field floatLabel="never">
                        <mat-select [formControl]="tipo">
                            <mat-select-trigger>
                                Cuenta {{ tipo.value | titlecase }}
                            </mat-select-trigger>
                            <mat-option value="titular">
                                Cuenta Titular
                            </mat-option>
                            <mat-option value="beneficiario">
                                Cuenta Beneficiario
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="pt-3" *ngIf="userAccountType === 'B'">
                    <hr class="app-module-subtitle"/>
                    <p class="medium-text m-0">Mas detalles</p>
                    <p class="small-label pb-5">Ingresa el nombre del beneficiario</p>
                    <div class="multiple-separation">
                        <div class="input-field-card ">
                            <mat-label class="small-label pb-3">Nombre(s)</mat-label>
                            <mat-form-field floatLabel="never">
                                <div class="d-flex">
                                    <input matInput
                                           id="nombre"
                                           type="text"
                                           [formControl]="nombre"
                                           placeholder="Nombre(s)">
                                </div>
                            </mat-form-field>
                        </div>
                        <div class="input-field-card">
                            <mat-label class="small-label pb-3">Apellido Paterno</mat-label>
                            <mat-form-field floatLabel="never">
                                <div class="d-flex">
                                    <input matInput
                                           id="pap_paterno"
                                           type="text"
                                           [formControl]="pap_paterno"
                                           placeholder="Apellido Paterno">
                                </div>
                            </mat-form-field>
                        </div>
                        <div class="input-field-card">
                            <mat-label class="small-label pb-3">Apellido Materno</mat-label>
                            <mat-form-field floatLabel="never">
                                <div class="d-flex">
                                    <input matInput
                                           id="pap_materno"
                                           type="text"
                                           [formControl]="pap_materno"
                                           placeholder="Apellido Materno">
                                </div>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-step>
            <mat-step [completed]="verificationCompleted">
                <ng-template matStepLabel>
                    <p class="small-label m-0">Verificación de cuenta</p>
                    <p class=" medium-text m-0">
                        <strong *ngIf="accountType === 'email'">
                            {{ linkAccountForm.get('account').get('usuario').value }}
                        </strong>
                        <strong *ngIf="accountType === 'sms'">
                            {{ linkAccountForm.get('account').get('usuario').value | mask: '(000) 000-0000' }}
                        </strong>
                    </p>
                </ng-template>
                <div>
                    <div class="link-feature-message" *ngIf="verificationCompleted">
                        <img src="../../assets/img/checkmark-192.png"
                             width="96"
                             height="96"
                             alt="">
                        <div>
                            <h5>Se verifico correctamente la cuenta</h5>
                            <p>
                                Al agregar esta cuenta aceptas nuestros
                                terminos y condiciones de servicio.
                            </p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center alert alert-warning"
                         role="alert"
                         *ngIf="wrongCodeError && !verificationCompleted">
                        <mat-icon>clear</mat-icon>
                        <div>
                            <p class="small-label">
                                El codigo que has ingresado no coincide
                                con el que te hemos enviado. Intenta de nuevo.
                            </p>
                        </div>
                    </div>
                    <div [hidden]="verificationCompleted">
                        <p class="small-label mb-3">
                            Ingrese el código de verificación que se envió
                            a su  {{
                            (accountType === 'email')
                                ? 'correo electronico '
                                : 'numero de teléfono '
                            }}
                        </p>
                        <form [formGroup]="validationForm">
                            <div class="d-flex flex-row w-100">
                                <input matInput
                                       class="link-code-digit"
                                       type="text"
                                       mask="0"
                                       id="firstDigit"
                                       formControlName="firstDigit"
                                       (keyup)="focusOnComplete($event)"
                                       placeholder="1">

                                <input matInput
                                       class="link-code-digit"
                                       type="text"
                                       mask="0"
                                       id="secondDigit"
                                       formControlName="secondDigit"
                                       (keyup)="focusOnComplete($event)"
                                       placeholder="2">

                                <input matInput
                                       class="link-code-digit"
                                       type="text"
                                       mask="0"
                                       id="thirdDigit"
                                       formControlName="thirdDigit"
                                       (keyup)="focusOnComplete($event)"
                                       placeholder="3">

                                <input matInput
                                       class="link-code-digit"
                                       type="text"
                                       mask="0"
                                       id="fourDigit"
                                       formControlName="fourDigit"
                                       (keyup)="focusOnComplete($event)"
                                       placeholder="4">

                                <input matInput
                                       class="link-code-digit"
                                       type="text"
                                       mask="0"
                                       id="fiveDigit"
                                       formControlName="fiveDigit"
                                       (keyup)="focusOnComplete($event)"
                                       placeholder="5">

                                <input matInput
                                       class="link-code-digit"
                                       type="text"
                                       mask="0"
                                       id="sixDigit"
                                       formControlName="sixDigit"
                                       (keyup)="focusOnComplete($event)"
                                       placeholder="6">
                            </div>
                            <div class="mt-5 mb-5">
                                <p class="small-label mb-3"><strong>¿No llego el codigo?</strong></p>
                                <button mat-raised-button
                                        #resendCodeBtn
                                        class="link-resend-btn"
                                        [disabled]="!canResendTimer"
                                        [ngStyle]=" {
											'background': '#0c4d94',
											'color': 'white',
											'font-size': '14px'
										}"
                                        (click)="verifyLinkedAccount()">
                                    Reenviar codigo <strong #timer></strong>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
    <div class="multiple-separation-bottom-actions link-account-bottom" *ngIf="userSelectedLinkType">
        <button mat-flat-button
                class="role-action-btn w-100"
                (click)="onNextStep()"
                type="button">
            <span class="material-symbols-rounded text-white">arrow_forward</span>
            Siguiente
        </button>
        <button mat-flat-button
                [hidden]="onLastStep"
                class="link-action-btn w-100"
                (click)="onPrevStep()"
                type="button">
            <span class="material-symbols-rounded">arrow_back</span>
            Regresar
        </button>
    </div>
</div>

<ng-template #serverErrorModal>
    <div class="modal-container">
        <h4 class="link-modal-title">
            <strong>Ocurrio un problema</strong>
        </h4>
        <p class="small-label">
            Probablemente se trate de un problema tecnico.
            Por favor intenta realizar el proceso en unos minutos.
        </p>
        <div class="dialog-actions">
            <button (click)="cancel()"
                    mat-raised-button>
                Aceptar
            </button>
        </div>
    </div>
</ng-template>
<ng-template #resultModal>
    <div class="modal-container">
        <h4 class="link-modal-title">
            <strong>{{ result.mensaje }}</strong>
        </h4>
        <p class="small-label">
            {{
            (result.statuscode == 200)
                ? 'La cuenta se ha vinculado correctamente. Ya puedes acceder con la cuenta para revisar saldos en CaliWallet.'
                : 'Ha ocurrido un error al vincular la cuenta. Intenta de nuevo mas tarde.'
            }}
        </p>
        <div class="dialog-actions">
            <button (click)="cancel()"
                    mat-flat-button>
                Aceptar
            </button>
        </div>
    </div>
</ng-template>
